module.exports = __webpack_public_path__ + "img/herrametal-logo-blue.99ad2936.png";